import DecisionFooter from '../DecisionFooter.jsx';

/**
 * Default decision bar: the event's single primary action (event.actionLabel)
 * plus the shared general actions and team overflow. Per-event-type stories
 * register richer decisions (multiple primary actions + confirm modals).
 */
function GenericDecision({ event, actions }) {
  return (
    <DecisionFooter
      event={event}
      onPrimary={actions.primary}
      onSkip={actions.skip}
      onAsk={actions.ask}
      onEscalate={actions.escalate}
      onTrace={actions.trace}
      extraMenuItems={actions.extraMenuItems}
      sticky={actions.sticky}
    />
  );
}

export default GenericDecision;
